import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { LanguageService } from '../../../../../../app.common/modules/common/services/languge.service';
import { PhysicalProductListItem } from '../../../../core';
import { IRetailerRootScope } from '../../../../core/models';
import { IPhysicalProductVariationListItem } from '../../../models';

class ProductEditPrice implements ng.IController {
    public static $inject = ['$rootScope', 'languageService'];
    public variation: IPhysicalProductVariationListItem;
    public product: PhysicalProductListItem;
    public waiting: boolean;
    public countryID: number;
    public currentCurrencyClass: string;
    public onPriceChange: (message: any) => any;
    public onCancelPrice: (message: any) => any;

    constructor(private $rootScope: IRetailerRootScope, private languageService: LanguageService) {}

    public $onInit() {
        this.countryID =  this.$rootScope.userData.countryID;
        this.currentCurrencyClass = this.languageService.getLangCurrencyStyle(this.countryID);
    }

    public changeVariationPrice() {
        const message = {
            product: this.product,
            variation: this.variation
        };
        this.onPriceChange({changedPrice: message});
    }

    public cancelPrice() {
        this.onCancelPrice({value: true});
    }

    public clearEatInTakeawayError() {
        this.variation.error.takeawayGreatEatIn = null;
    }
}

angular.module('naut').component('productEditPrice', {
    template: require('./edit-price-modal.component.html'),
    controller: ProductEditPrice,
    controllerAs: 'vm',
    bindings: {
        variation: '<',
        product: '<',
        waiting: '<',
        onPriceChange: '&',
        onCancelPrice: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/modals/edit-price-modal/edit-price-modal.component.ts